import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  historyButtons: {
    marginLeft: theme.spacing(1),
  },
  drawerCloseBtn: {
    width: "80px",
    display: "flex",
    justifyContent: "center",
    margin: theme.spacing(2),
    float: "right",
  },
  bottomButtons: {
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.background.paper,
    zIndex: theme.zIndex.drawer + 1,
  },
  buttonWrapper: {
    padding: theme.spacing(0, 3),
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0),
  },
  closeButton: {
    minWidth: 100,
  },
  divider: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  historyContent: {
    flex: 1,
    overflowY: "auto",
  },
}));